import { AddCircleOutline } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'
import { CommonPageLayout } from 'src/components/common/CommonPageLayout'
import { useCustomerCtx, useDialogCtx } from 'src/hooks/context-hooks'
import { CustomerDocumentCategoryTableContainer } from 'src/containers/document-categories/CustomerAdminDocumentCategoryTableContainer'
import { CreateCustomerDocumentCategoryDialog } from 'src/components/document-categories/customer-admin/CreateCustomerDocumentCategoryDialog'
import { useEffect, useState } from 'react'
import { DialogSpinner } from 'src/components/Spinner'

export const DocumentCategoriesContainer = () => {
  const { t: translate } = useTranslation(['document-category', 'common', 'common-api-message'])
  const { showDialog } = useDialogCtx()
  const [customerId, setCustomerId] = useState<EntityId>(0)
  const { customer } = useCustomerCtx()

  useEffect(() => {
    setCustomerId(customer.id)
  }, [customer])

  if (!customerId) {
    return <DialogSpinner />
  }

  const onAddDocumentCategory = async () => {
    const added = await showDialog(
      CreateCustomerDocumentCategoryDialog,
      {
        componentProps: { customerId: customerId },
        opts: {
          maxWidth: 'sm',
          fullWidth: true,
        },
      },
      undefined,
      true,
    )
    if (!added) return
  }

  return (
    <>
      <CommonPageLayout
        titleSection={{ title: translate('documentCategories', { ns: 'document-category' }) }}
        topAction={[
          {
            buttonText: translate('document-category', { ns: 'document-category' }),
            buttonIcon: <AddCircleOutline />,
            onClick: onAddDocumentCategory,
            variant: 'outlined',
            shadowWeight: null,
            border: 0,
          },
        ]}
      >
        <CustomerDocumentCategoryTableContainer />
      </CommonPageLayout>
    </>
  )
}
